import React from 'react';

function Footer() {
    return ( 
        <footer>
            <p>Copyright © 2023 Reiine Iangar. All Rights Reserved</p>
        </footer>
     );
}

export default Footer;